import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import {store} from './store/store'
import VueSession from 'vue-session'
import {Conf} from './conf/defaults'

export const serverBus = new Vue()

Vue.config.productionTip = false

var options = {
  persist: true
}

Vue.use(VueSession, options)

Vue.prototype.$windowTitle = Conf.windowTitle

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
